const footerFr = {
    "follow_us": "Suivez-nous!",
    "all_rights_reserved": "© 2024 Code Kitchen Kft. Tous droits réservés.",
    "terms_and_conditions": "Termes et conditions",
    "privacy_policy": "politique de confidentialité"
};

export default footerFr;
